import { useSession } from 'next-auth/react';

import RoleTypes from 'lib/constants/role-types.ts';

/**
 * Wraps the useSession hooks with our config to have it used correctly
 */
export function useUser() {
  const { data: session } = useSession({ required: true });
  const userName = session?.user?.name ?? undefined;
  const userEmail = session?.user?.email ?? undefined;
  const userId = session?.user?.id ?? undefined;

  const roles = session?.user?.roles ?? [];
  const permissions = session?.user?.permissions ?? [];

  const isAdmin = Boolean(session?.user.roles.includes(RoleTypes.ADMIN));

  return { userName, userEmail, isAdmin, roles, permissions, userId };
}
